import { Chip, Tooltip } from "@mui/material";
import React from "react";

import { badgeText, nonverbalOf } from "./nonverbal.js";

const STATE_TEXT = {
    applied: "Added automatically",
    suggested: "Suggested",
    rejected: "Rejected",
};

// Marks a region or line that non-verbal detection wrote, with what it heard
// and how sure it was. Renders nothing for manual items.
const NonverbalBadge = ({ item, size = "small" }) => {
    const nonverbal = nonverbalOf(item);
    if (!nonverbal) {
        return null;
    }
    const state = STATE_TEXT[nonverbal.state] || "Added automatically";
    const reviewed = nonverbal.reviewed ? ", reviewed" : "";
    const evidence = Array.isArray(nonverbal.evidence) && nonverbal.evidence.length
        ? ` Heard by: ${nonverbal.evidence.join(", ")}.`
        : "";
    return (
        <Tooltip title={`${state}${reviewed}.${evidence}`}>
            <Chip
                size={size}
                label={`Auto · ${badgeText(nonverbal)}`}
                color={nonverbal.state === "suggested" ? "warning" : "info"}
                variant={nonverbal.reviewed ? "filled" : "outlined"}
                data-testid="nonverbal-badge"
            />
        </Tooltip>
    );
};

export default NonverbalBadge;
